var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: 800,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        cancelText: _vm.language["common.closeButton"]
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model-item",
            {
              attrs: {
                label: _vm.language["legalperson"],
                labelCol: _vm.labelCol,
                wrapperCol: _vm.wrapperCol,
                prop: "legalpersonList"
              }
            },
            [
              _c(
                "a-checkbox-group",
                {
                  model: {
                    value: _vm.model.legalpersonList,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "legalpersonList", $$v)
                    },
                    expression: "model.legalpersonList"
                  }
                },
                _vm._l(_vm.legalpersonOptions, function(item, index) {
                  return _c(
                    "a-checkbox",
                    { key: index, attrs: { value: item.value } },
                    [_vm._v(_vm._s(item.label))]
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }